import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useChangeMobileNumberFlow from "../../../hooks/useChangeMobileNumberFlow";
import RenewMotorLayout from "../../motorInsurancePages/renewalMotorPolicy/renewMotorLayout";
import TitleDescription from "../../../components/newMotorPolicy/titleDescription/titleDescription";
import VerifyOtpComponent from "../../motorInsurancePages/renewalMotorPolicy/verifyOtpPage/verifyOtpComponent";
import Button from "../../../components/common/Button/Button";
import { unwrapResult } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "sonner";
import { changeMobile, selectIsLoading as selectChangeMobileLoading } from "../../../redux/features/account/updateMobileApiSlice";
import { selectNewMotorForm } from "../../../redux/features/newMotorFormSlice";
import { CHANGE_MOBILE_FLOW_UPDATED_MOBILE_NUMBER } from "./changeMobileNumberPage";
import { CHANGE_MOBILE_FLOW_ACCOUNT_PASSWORD } from "./accountPasswordPage";
import {
  getTokenOtpLoading,
  sendToken,
} from "../../../redux/features/account/accountOtpSlice";
import StickyActionBar from "../../../components/common/stickyActionBar/StickyActionBar";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";

const VerifyOtp = ({}) => {
  const dispatch = useDispatch();
  const translate = useLanguageTranslate();
  const { handleNextSubstep, handlePrevSubstep } = useChangeMobileNumberFlow();
  const updatedPhnDetails = useSelector(selectNewMotorForm);
  const isLoading = useSelector(getTokenOtpLoading);
  const isChangeMobileLoading = useSelector(selectChangeMobileLoading);
  const mobileNum =
    updatedPhnDetails?.[CHANGE_MOBILE_FLOW_UPDATED_MOBILE_NUMBER]?.["phone"];

  const [otp, setOtp] = useState();
  const { t } = useTranslation();
  // const notRecivedCodeHandler = () => {
  //   alert("clicked on i didn't recieved code");
  // };
  const notRecivedCodeHandler = async () => {
    try {
      const tokenOtpPayload = {
        mobileNumber: mobileNum,
      };

      const tokenOtpAction = await dispatch(sendToken(tokenOtpPayload));
      const tokenOtpResult = unwrapResult(tokenOtpAction);

      // If the response is successful, process the phone number
      if (tokenOtpResult?.smsStatus =="MESSAGE_SENT") {
        toast.success(
          translate("We've sent you a new code.", "أرسلنا إليك رمزًا جديدًا.")
        );
      } else if (
        tokenOtpResult &&
        tokenOtpResult.smsStatus =="MESSAGE_NOT_SENT"
      ) {
        toast.error(
          translate(
            "We couldn't send the code. Please try again.",
            "تعذّر إرسال الرمز. يرجى المحاولة مرة أخرى."
          )
        );
      } else if (
        tokenOtpResult?.requestError?.serviceException?.messageId ===
        "THROTTLE_EXCEPTION"
      ) {
        toast.error(tokenOtpResult.requestError.serviceException.text);
      }
    } catch (error) {
      toast.error(
        translate(
          "We couldn't send the code. Please try again.",
          "تعذّر إرسال الرمز. يرجى المحاولة مرة أخرى."
        )
      );
    }
  };

  const continueClickHanlder = async () => {
    try {
      const payload = {
        Password:
          updatedPhnDetails?.[CHANGE_MOBILE_FLOW_ACCOUNT_PASSWORD][
            "accountPassword"
          ],
        Phone:
          updatedPhnDetails?.[CHANGE_MOBILE_FLOW_UPDATED_MOBILE_NUMBER][
            "phone"
          ],
        Pin: otp,
        PinId:
          updatedPhnDetails?.[CHANGE_MOBILE_FLOW_UPDATED_MOBILE_NUMBER][
            "pinId"
          ],
      };

      // Calling API /account/updateMobile
      const updateMobileAction = await dispatch(changeMobile(payload));
      const updateMobileResult = unwrapResult(updateMobileAction);
      if (updateMobileResult) {
        toast.success(
          translate(
            "Updated mobile number successfully",
            "تم تحديث رقم الهاتف بنجاح"
          )
        );
        handleNextSubstep();
      }
    } catch (error) {
      toast.error(
        translate(
          "We couldn't update your mobile number. Please check the code and try again.",
          "تعذّر تحديث رقم هاتفك. يرجى التحقق من الرمز والمحاولة مرة أخرى."
        )
      );
    }
  };

  return (
    <RenewMotorLayout
      is_bottom_sticky_layout={false}
      backClickHandler={() => handlePrevSubstep()}
    >
      <div className="mx-auto bg-white max767:p-5 w-[500px] max-w-[100%] max767:mt-[60px] mt-20">
        <div className="reniewlotp">
          <TitleDescription
            className="mb-6"
            title={translate("Verify OTP", "التحقق من الرمز")}
            description={translate(
              "Enter the 4-digit code we sent to your new number.",
              "أدخل الرمز المكوّن من 4 أرقام الذي أرسلناه إلى رقمك الجديد."
            )}
          />
          <VerifyOtpComponent
            notRecivedCodeHandler={notRecivedCodeHandler}
            otp={otp}
            setOtp={setOtp}
            mobile={mobileNum}
            onChangeClick={handlePrevSubstep}
          />
        </div>
        <StickyActionBar>
          <Button
            type="submit"
            className="primary-button mt-6 max767:mt-0 transition-[background-color,transform] duration-150 ease-out active:scale-[0.98] disabled:active:scale-100"
            onSubmit={continueClickHanlder}
            label={t("forgot_password_flow.reset_password.next")}
            disabled={!(otp?.length ==4) || isChangeMobileLoading || isLoading}
            isLoading={isChangeMobileLoading || isLoading}
          />
        </StickyActionBar>
      </div>
    </RenewMotorLayout>
  );
};

export default VerifyOtp;
